import Control from 'models/control';
import Risk from 'models/risk';
import Theme from 'models/theme';
import Process from './process';
import Asset from 'models/asset/asset';
import ProcessingActivity from 'models/processingActivity';

export class ProcessContext {
  parent: Process | undefined;

  children: Process[];

  controls: Control[];

  themes: Theme[];

  risks: Risk[];

  assets: Asset[];

  processingActivities: ProcessingActivity[];

  constructor() {
    this.parent = new Process();
    this.children = [];
    this.controls = [];
    this.themes = [];
    this.risks = [];
    this.assets = [];
    this.processingActivities = [];
  }
}
